var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M15.38 13.395c.272.096 1.726.809 2.018.958.293.144.49.218.56.351.074.123.074.714-.171 1.406s-1.421 1.32-1.991 1.405c-.937.139-1.672.07-3.546-.74-2.965-1.283-4.898-4.264-5.047-4.461C7.06 12.117 6 10.711 6 9.258s.761-2.167 1.033-2.465c.271-.293.59-.367.788-.367.197 0 .394 0 .564.01.181.011.426-.069.666.506.244.591.835 2.045.91 2.194s.122.32.027.516c-.565 1.129-1.172 1.091-.868 1.613 1.144 1.965 2.284 2.646 4.02 3.514.292.149.468.122.638-.075.176-.202.74-.862.937-1.16s.394-.25.666-.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10"
  })));
};
export default SvgPhone;